(function(){
	'use strict';

	angular
		.module('app.contact')
		.controller('BudgetController', BudgetController);

	function BudgetController(API, $scope, $filter) {
		let vm = this;

		vm.acabamentos = [
			'Chapa forro',
			'Filme',
			'Telha',
		];

		vm.pintura = [
			'Natural',
      'Preto',
      'Branco',
      'Cinza',
      'Laranja',
      'Azul',
      'Verde',
      'Vermelho',
      'Bege',
      'Marrom Claro',
      'Marrom Escuro',
      'Amarelo',
		];

		vm.loadProductModels = value => {
			value = angular.copy(value);
			vm.productsModel = [];
			if(value && !+value.is_produto) {
				API.get(`produto_brastelha/categoria/${value.slug}`)
					.then(result => result.data)
					.then(products => vm.productsModel = products.map(product => {
	          product.image = $filter('imgUrl')(product.img);
	          return product;
	        }))
					.catch(error => {
					  console.log(error, 'error');
					});
			}
		};

		vm.sendBudget = budget => {
			let formData = angular.copy(budget);
			formData.produto = formData.product.nome;
			if(!formData.temIsolamento){
				delete formData.isolamento;
			}
			delete formData.product;
			API.post('budget', formData)
				.then(result => swal('Enviado com sucesso!', '', 'success'))
			   	.then(() => {
	  				angular.copy({}, budget)
	  				vm.ItsOkayForm.$submitted = false;
	  				vm.ItsOkayForm.$setPristine();
			   	})
				.then(console.log);
		}

		vm.$onInit = () => {
			_loadFromApi();
		}

		vm.submitBudget = (Budget) => {
			_loadCategoriesProducts();
		}

		function _loadFromApi() {
			_loadCategoriesProducts();
			_loadEnderecos();
		}

		function _loadEnderecos() {
		  API.get(`endereco`)
				.then(result => result.data)
				.then(enderecos => vm.enderecos = enderecos)
				.catch(error => {
				  console.log(error, 'error');
				});
		}

		function _loadCategoriesProducts() {
			API.get(`produto_brastelha/categoria`)
				.then(result => result.data)
				.then(products => vm.products = products)
				.catch(error => {
					console.error(error, 'error');
				});
		}

	}

})();
